import * as React from 'react';
import { connect } from 'react-redux';
import { ApplicationState } from '../../../store';
import { PostImportActionEnum, SftpImportConfigurationWorkflow, getPostImportActionDescriptions } from '../../../store/Models/Api/SftpImportModels';
import { RadioButtonGroup } from '../../core/RadioButtonGroup';
import { DropdownMenu } from '../../core/DropdownMenu';
import { ToxnotComponent, ToxnotComponentProperties } from '../../core/BaseApplicationComponents/ToxnotComponent';
import { PostImportActionSection } from '../sections/PostImportActionSection';
import { ScheduleConfigurationSection } from '../sections/ScheduleConfigurationSection';
import { StepNavigationButtons } from '../components/StepNavigationButtons';

interface ScheduleStepLocalProps {
    goToNextStep: () => void;
    goToPrevStep: () => void;
    configData: SftpImportConfigurationWorkflow;
    onConfigChange: (data: Partial<SftpImportConfigurationWorkflow>) => void;
}

type ScheduleStepProps = ScheduleStepLocalProps & ToxnotComponentProperties;

class ScheduleStepComponent extends ToxnotComponent<ScheduleStepProps> {
    componentDidMount() {
        // Set default timezone to EST
        this.props.onConfigChange({ timeZone: 'EST' });
    }

    public handleTimeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        this.props.onConfigChange({ startTime: e.target.value });
    }

    public handleTimeBlur = (e: React.ChangeEvent<HTMLInputElement>) => {
        const time = e.target.value;
        if (!time) return;

        const [hours, minutes] = time.split(':').map(Number);

        if (isNaN(hours) || isNaN(minutes)) return;

        const roundedMinutes = Math.round(minutes / 30) * 30;
        let newHours = hours;

        if (roundedMinutes === 60) {
            newHours = (hours + 1) % 24; // handle day overflow
        }

        const newMinutesValue = roundedMinutes === 60 ? 0 : roundedMinutes;

        const newTime = `${newHours.toString().padStart(2, '0')}:${newMinutesValue.toString().padStart(2, '0')}`;
        this.props.onConfigChange({ startTime: newTime });
    }

    render() {
        const { configData, onConfigChange, appServices } = this.props;

        return (
            <div>
                <div className="grouped-data">
                    <PostImportActionSection 
                        configData={configData}
                        onConfigChange={onConfigChange}
                    />
                    <ScheduleConfigurationSection 
                        configData={configData}
                        onConfigChange={onConfigChange}
                        onTimeChange={this.handleTimeChange}
                        onTimeBlur={this.handleTimeBlur}
                    />
                </div>
                
                <StepNavigationButtons 
                    onPrevious={this.props.goToPrevStep}
                    onNext={this.props.goToNextStep}
                />
            </div>
        );
    }
}

export const ScheduleStep = connect(
    (state: ApplicationState) => ({ appServices: state.appServices! })
)(ScheduleStepComponent);